import api from './axios';
import {
  AdminLoginRequest,
  AdminLoginResponse,
  AdminRegisterRequest,
} from './types/adminAuth';
import { clearAdminAuthCookies } from '@/lib/cookies';

export const adminAuthService = {
  async login(credentials: AdminLoginRequest): Promise<AdminLoginResponse> {
    try {
      const response = await api.post<AdminLoginResponse>(
        '/authentication/admin-user-login',
        credentials
      );

      if (response.data?.data?.auth_key) {
        const authKey = response.data.data.auth_key;
        if (typeof window !== 'undefined') {
          localStorage.setItem('adminToken', authKey);
        }
      }

      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('📡 [adminAuthService] Error response:', {
          status: error.response.status,
          data: error.response.data,
        });
      }

      throw error;
    }
  },

  async register(userData: AdminRegisterRequest): Promise<any> {
    try {
      const response = await api.post(
        '/authentication/admin-user-register',
        userData
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('📡 [adminAuthService] Registration error:', {
          status: error.response.status,
          data: error.response.data,
        });
      }
      throw error;
    }
  },

  isAdminLoggedIn(): boolean {
    if (typeof window === 'undefined') return false;

    const adminToken = localStorage.getItem('adminToken');
    return !!adminToken;
  },

  logout(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUserId');

    clearAdminAuthCookies();
  },

  getAdminToken(): string | null {
    if (typeof window === 'undefined') return null;

    return localStorage.getItem('adminToken');
  },
};

export default adminAuthService;
